var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTogether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "together 1",
    clipPath: "url(#clip0_719_1480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_719_1480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2559",
    d: "M0 3.8147e-06H42V42H0V3.8147e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_719_1480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2565",
    d: "M9.19312 10.0094C10.1359 9.02429 11.1623 7.96428 12.2889 7.19991",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2569",
    d: "M32.8068 31.9906C32.2736 32.5477 31.6872 33.156 31.1145 33.6754",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2573",
    d: "M12.956 6.8209C13.7804 6.38039 14.7262 6.05793 15.8985 5.88574C17.6047 5.63555 19.2175 5.3993 20.178 5.13023C22.1164 4.58719 23.4609 2.83336 23.4609 0.820312H18.5391C11.6648 0.820312 8.23348 3.8932 5.63965 6.60269C4.16883 8.13996 2.76609 9.58699 0.820312 10.2596V18.5391H1.88672C5.98582 18.5391 9.91758 16.3725 12.7509 13.4105C13.7878 12.3252 14.5146 11.5704 15.2471 11.1759C16.444 10.5328 16.8935 9.03984 16.2471 7.84301C15.6105 6.66012 14.1455 6.20977 12.956 6.8209ZM12.956 6.8209C12.4879 7.06871 12.0611 7.35418 11.646 7.67977",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2577",
    d: "M6.96199 29.2983C6.38097 28.2948 6.05423 27.2481 5.88574 26.1015C5.63555 24.3952 5.3993 22.7825 5.13023 21.8219C4.58719 19.8835 2.83336 18.5391 0.820312 18.5391V23.4609C0.820312 30.3352 3.8932 33.7665 6.6027 36.3604C8.13996 37.8312 9.58699 39.2339 10.2596 41.1797H18.5391V40.1133C18.5391 36.0142 16.3726 32.0823 13.4105 29.249C12.3252 28.2122 11.5705 27.4853 11.1759 26.7529C10.5328 25.556 9.03984 25.1064 7.84301 25.7529C6.69605 26.3701 6.1028 27.8579 6.96199 29.2983ZM6.96199 29.2983C7.23409 29.7723 7.6248 30.3293 8.19492 30.9701",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2581",
    d: "M10.0094 32.8068C9.46256 32.2835 8.847 31.6906 8.32446 31.1145",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2585",
    d: "M33.8051 11.0299C34.3639 11.6645 34.7441 12.1556 35.1791 12.956M35.1791 12.956C35.6196 13.7804 35.942 14.7263 36.1143 15.8985C36.3645 17.6047 36.6007 19.2175 36.8698 20.1781C37.4128 22.1164 39.1666 23.4609 41.1797 23.4609V18.5391C41.1797 11.6648 38.1068 8.23348 35.3973 5.63965C33.86 4.16883 32.413 2.76609 31.7404 0.820312H23.4609V1.88672C23.4609 5.98582 25.6274 9.91758 28.5895 12.7509C29.6748 13.7878 30.4295 14.5146 30.8241 15.2471C31.4672 16.444 32.9602 16.8935 34.157 16.2471C35.3399 15.6105 35.7902 14.1455 35.1791 12.956Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2589",
    d: "M31.9905 9.19328C32.6865 9.85929 33.5585 10.6996 34.1896 11.4802",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2593",
    d: "M18.5391 17.3086C20.4094 17.3086 21 19.4414 21 19.4414C21 19.4414 21.5906 17.3086 23.4609 17.3086C24.9178 17.3086 25.9219 18.5317 25.9219 19.9804C25.9219 21.146 25.2435 22.0828 24.1008 23.1615C23.2796 23.9351 22.2198 24.7825 21 25.8398C18.0813 23.31 16.0781 21.9836 16.0781 19.9804C16.0781 18.5317 17.0822 17.3086 18.5391 17.3086Z",
    stroke: "#D62C72",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2597",
    d: "M35.4375 37.0781C35.4375 37.5311 35.0702 37.8984 34.6172 37.8984C34.1641 37.8984 33.7969 37.5311 33.7969 37.0781C33.7969 36.6251 34.1641 36.2578 34.6172 36.2578C35.0702 36.2578 35.4375 36.6251 35.4375 37.0781Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2601",
    d: "M30.9701 33.8051C29.4252 35.1682 28.0109 35.8336 26.1015 36.1143C24.3953 36.3645 22.7825 36.6007 21.822 36.8698C19.8836 37.4128 18.5391 39.1666 18.5391 41.1797H23.4609C26.9617 41.1797 29.5696 40.3828 31.6286 39.2428",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2605",
    d: "M37.2438 34.487C38.4169 33.3097 39.6249 32.2779 41.1796 31.7404V23.461H40.1132C36.0141 23.461 32.0824 25.6274 29.2491 28.5895C28.2121 29.6749 27.4854 30.4295 26.7528 30.8241C25.556 31.4672 25.1065 32.9602 25.7528 34.157C26.3802 35.3228 27.8735 35.8879 29.2983 35.0381",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_1480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogether);
export default __webpack_public_path__ + "static/media/together.2eba4edb5a2b7bc959d4169fbe2c4789.svg";
export { ForwardRef as ReactComponent };